import cn from 'classnames';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import { NavigationBarVariant } from '../../components/NavigationBar/models';
import NewNavigation from '../../components/NewNavigation';
import Form from '_components/Form';
import FormModal from '_components/FormModal';
import { FormId } from '_constants/forms';
import { Hubspot } from '_constants/destinations';
import { FORM_TYPE } from '_utils/analytics/constants';
import { graphql, useStaticQuery } from 'gatsby';

interface LayoutProps {
  navigationBarVariant?: NavigationBarVariant;
  primaryButtonId?: string;
  secondaryButtonId?: string;
  hideNav?: boolean;
  locale?: string;
  theme?: string;
  page?: string;
  localesAvailable?: any;
  footerRef?: React.RefObject<HTMLDivElement>;
}

const Layout: React.FC<React.PropsWithChildren<LayoutProps>> = props => {
  const { language } = useI18next();
  const { t } = useTranslation();

  const [activeFormModal, setActiveFormModal] = useState<boolean>(false);

  const data = useStaticQuery(graphql`
  query ($language: String) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    termsAndConditions: allContentfulMarketingWebTranslations(
    filter: {
      key: { eq: "form.terms_and_conditions" }
      node_locale: { eq: $language }
    }
  ) {
    nodes {
      title
      translation {
        translation
        childMdx {
          body
        }
      }
    }
  }
  }
`);


  const {
    children,
    hideNav = false,
    theme = 'light',
    page,
    localesAvailable,
    footerRef,
  } = props;

  return (
    <div
      // overflow hidden on this will break the navigation sticky bar, add deeper in children if needed
      className={cn(
        {
          'bg-black': theme === 'dark',
        },
        'relative min-h-screen'
      )}
    >
      {!hideNav && (
        <NewNavigation page={page} localesAvailable={localesAvailable} />
      )}
      <main>{children}</main>
      <Footer localesAvailable={localesAvailable} footerRef={footerRef} page={page} locale={language} />

      {activeFormModal && (
        <Form formId={FormId.STARTUP}>
          <FormModal
            formId={Hubspot.STARTUP_FORM_ID}
            setActiveModal={setActiveFormModal}
            title={t('Apply for the Perpetua for Startups program')}
            formType={FORM_TYPE.STARTUP}
            data={activeFormModal}
            termsAndConditions={data.termsAndConditions.nodes[0]}
          />
        </Form>
      )}
    </div>
  );
};

export default Layout;
